export default __webpack_public_path__ + "static/media/Dead (1).b5809ba1.png";